import { helpLinks, legalLinks } from 'app/common/links';
import type React from 'react';
import { useCallback } from 'react';
import styled from 'styled-components';

const HelpMenuList = styled.ul`
  list-style-type: none;
  padding-left: 0;

  .liveChat {
    cursor: pointer;
  }

  li {
    font-size: 1rem;
    margin: ${({ theme }) => theme.spacing(2)} 0;
    padding: 0 ${({ theme }) => theme.spacing(2)};
  }

  a {
    color: ${({ theme }) => theme.palette.text.primary};
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }
`;

const Legal = styled('small')`
  display: block;
  font-size: 0.75rem;

  a {
    color: ${({ theme }) => theme.palette.text.secondary};
    display: inline-block;
    margin: 0 0.625rem;

    &:first-child {
      margin: 0;
    }
  }
`;

export type HelpMenuProps = {
  readonly loggedIn?: boolean;
  readonly inProject?: boolean;
  readonly trackEvent: (event: string) => void;
};

/** Presents a hard-coded list of helpful links and utilities,
 */
export const HelpMenu: React.FC<HelpMenuProps> = (props) => {
  const { trackEvent } = props;
  const trackOnClick = useCallback(
    (eventName: string) => () => {
      trackEvent(eventName);
    },
    [trackEvent]
  );

  return (
    <HelpMenuList data-testid="help-menu-list">
      {helpLinks.map(({ href, label, track }) => (
        <li key={label}>
          <a onClick={track ? trackOnClick(track) : undefined} href={href} target="_blank" rel="noopener noreferrer">
            {label}
          </a>
        </li>
      ))}
      <li>
        <Legal>
          {legalLinks.map(({ href, label, track }) => (
            <a
              key={label}
              onClick={track ? trackOnClick(track) : undefined}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {label}
            </a>
          ))}
        </Legal>
      </li>
    </HelpMenuList>
  );
};

export default HelpMenu;
